import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize, getFontFamily} from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 8px
`;

const Title = styled.div<{ weight: string }>`
    font-size: ${getFontSize('small')};
    font-family: ${getFontFamily('atlassian')};
    color: ${getColor('blue')};
    font-weight: ${({ weight }) => weight};
    margin-bottom: 5px;
    align-items: center;
`;

type Props = {
    title: string;
    weight?: string;
}

export const Section: React.FC<Props> = ({
    title,
    weight
}) => (
    <Wrapper>
        <Title weight={weight}>{title}</Title>
    </Wrapper>
);

